import NavigationDrawerBackground from "@voxmedia/duet-ui/components/brand/theverge/NavigationDrawerBackground/NavigationDrawerBackground";
import VergeSubscribeButton from "@voxmedia/duet-ui/components/brand/theverge/VergeSubscribeButton";
import { NavigationDrawerConfig } from "@voxmedia/duet-ui/components/navigation/Navigation/Navigation";
import DrawerThemeSwitcher from "src/components/DrawerThemeSwitcher";

/** Drawer chrome for CSK stories that opt in via `drawerThemeSwitcher` page props. */
export const vergeGetDrawerComponents = (): NavigationDrawerConfig => ({
  background: <NavigationDrawerBackground />,
  endSection: <VergeSubscribeButton />,
  shortcutBar: <DrawerThemeSwitcher />,
});
